import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { IAdContent } from 'src/interface';
import { trackingAdNative, tracking as trackingImg } from 'src/utils/tracking';

export const useTracking = (
    zoneId: string,
    tracking: string = '',
    adNative?: IAdContent
) => {
    const [inViewRef, inView] = useInView({ triggerOnce: true, threshold: 1 });
    useEffect(() => {
        if (inView && zoneId) {
            const viewableImp = adNative?.tracking.viewableImp[0] || '';
            trackingImg(viewableImp, {});
            let source = tracking ? tracking.replace(/\|/g, '/') + '/' : '';
            if (source && source[0] === '/') {
                source = source.substring(1);
            }
            const key = 'mobiletrack/imps/' + source + 'pr';
            const keyPr = 'mobiletrack/imps/pr/' + zoneId;
            trackingAdNative(key);
            trackingAdNative(keyPr);
        }
    }, [inView, zoneId]);

    return inViewRef;
};
